<template>
    <div>
        <transition name="fade" appear>
            <div v-if="!capRunning" class="welcome-landing-root">
                <welcome-landing :courses="featuredCourses || []" :loading="landingLoading" />
            </div>
        </transition>

        <app-welcome-dialog v-if="platform == 'ios'" v-model="appWelcomeDialog" />
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import AppWelcomeDialog from '@/components/default/dialogs/app-welcome'
import WelcomeLanding from '@/components/welcome/landing/WelcomeLanding.vue'

export default {
    name: "Welcome",
    data(){
        return {
            coursesLoading: false,
        }
    },
    components: {
        AppWelcomeDialog,
        WelcomeLanding,
    },
    computed: {
        ...GlobalComputed,
        welcomeData(){
            return this.$store.state.globalModule.welcomeData;
        },
        featuredCourses(){
            return this.welcomeData.featured_courses;
        },
        landingLoading(){
            return !this.appLoadedOnce || this.coursesLoading;
        },
    },
    watch: {
        appLoadedOnce: {
            immediate: true,
            handler(loaded) {
                if (!loaded || this.capRunning) {
                    return;
                }
                if (!this.featuredCourses || !this.featuredCourses.length) {
                    this.loadData();
                }
            },
        },
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.coursesLoading){
                this.coursesLoading = true;

                this.$store.dispatch('loadWelcomeData').then(()=>{
                    this.coursesLoading = false;
                }).catch(()=>{
                    this.coursesLoading = false;
                });
            }
        },
    },
    created(){
        if (this.capRunning){
            if (this.platform === 'ios'){
                this.appWelcomeDialog = true;
            }else{
                this.$router.push({name: 'login'});
            }
        }
    }
};
</script>

<style src="@/scss/welcome-landing.css"></style>
